// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --bg-header-sidebar: #f1f2f7;

  --color-sidebar: #0d0d0d;
  --bg-sidebar-button: #f8f9fa;
  --bg-sidebar-button-hover: #ededec;

  --color-border-button: #dadade;

  --bg-main: #fefefe;

  --bg-message-system: #f9f9f9;
  --color-message-system: #0d0d0d;
  --color-border-message-system: #e7e6e6;

  --bg-message-user: #f2f3f3;

  --bg-chat-input-bar: #f1f2f7;
  --border-chat-input-bar: #e7e6e6;

  --scrollbar-color: #e2e2e3;
  --scrollbar-color-hover: #e2e2e3;

  --bg-popover: #f9f9f9;
  --color-border-popover: #e7e6e6;
  --bg-hover-popover: #f4f5f4;

    /* icon */
  --color-hamburger: #333;
}

[data-theme="dark"] {
  --bg-header-sidebar: #171616;

  --color-sidebar: #ececec;
  --bg-sidebar-button: #303030;
  --bg-sidebar-button-hover: #202021;

  --color-border-button: none;

  --bg-main: #202121;

  --bg-message-system: #303030;
  --color-message-system: #e2e2e2;
  --color-border-message-system: none;

  --bg-message-user: #303030;

  --bg-chat-input-bar: #2e2e2f;
  --border-chat-input-bar: #333;

  --scrollbar-color: #4b5563;
  --scrollbar-color-hover: #6b7280;

  --bg-popover: #2f2e2f;
  --color-border-popover: #434342;
  --bg-hover-popover: #414043;

  /* icon */
  --color-hamburger: #fff;
}


[data-theme='light'] img:not( [data-no-invert] ) {
  filter: invert(1);
}

body {
    margin: 0;
    padding: 0;
  }
  `, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,4BAA4B;;EAE5B,wBAAwB;EACxB,4BAA4B;EAC5B,kCAAkC;;EAElC,8BAA8B;;EAE9B,kBAAkB;;EAElB,4BAA4B;EAC5B,+BAA+B;EAC/B,sCAAsC;;EAEtC,0BAA0B;;EAE1B,4BAA4B;EAC5B,gCAAgC;;EAEhC,0BAA0B;EAC1B,gCAAgC;;EAEhC,qBAAqB;EACrB,+BAA+B;EAC/B,2BAA2B;;IAEzB,SAAS;EACX,uBAAuB;AACzB;;AAEA;EACE,4BAA4B;;EAE5B,wBAAwB;EACxB,4BAA4B;EAC5B,kCAAkC;;EAElC,2BAA2B;;EAE3B,kBAAkB;;EAElB,4BAA4B;EAC5B,+BAA+B;EAC/B,mCAAmC;;EAEnC,0BAA0B;;EAE1B,4BAA4B;EAC5B,6BAA6B;;EAE7B,0BAA0B;EAC1B,gCAAgC;;EAEhC,qBAAqB;EACrB,+BAA+B;EAC/B,2BAA2B;;EAE3B,SAAS;EACT,uBAAuB;AACzB;;;AAGA;EACE,iBAAiB;AACnB;;AAEA;IACI,SAAS;IACT,UAAU;EACZ","sourcesContent":[":root {\n  --bg-header-sidebar: #f1f2f7;\n\n  --color-sidebar: #0d0d0d;\n  --bg-sidebar-button: #f8f9fa;\n  --bg-sidebar-button-hover: #ededec;\n\n  --color-border-button: #dadade;\n\n  --bg-main: #fefefe;\n\n  --bg-message-system: #f9f9f9;\n  --color-message-system: #0d0d0d;\n  --color-border-message-system: #e7e6e6;\n\n  --bg-message-user: #f2f3f3;\n\n  --bg-chat-input-bar: #f1f2f7;\n  --border-chat-input-bar: #e7e6e6;\n\n  --scrollbar-color: #e2e2e3;\n  --scrollbar-color-hover: #e2e2e3;\n\n  --bg-popover: #f9f9f9;\n  --color-border-popover: #e7e6e6;\n  --bg-hover-popover: #f4f5f4;\n\n    /* icon */\n  --color-hamburger: #333;\n}\n\n[data-theme=\"dark\"] {\n  --bg-header-sidebar: #171616;\n\n  --color-sidebar: #ececec;\n  --bg-sidebar-button: #303030;\n  --bg-sidebar-button-hover: #202021;\n\n  --color-border-button: none;\n\n  --bg-main: #202121;\n\n  --bg-message-system: #303030;\n  --color-message-system: #e2e2e2;\n  --color-border-message-system: none;\n\n  --bg-message-user: #303030;\n\n  --bg-chat-input-bar: #2e2e2f;\n  --border-chat-input-bar: #333;\n\n  --scrollbar-color: #4b5563;\n  --scrollbar-color-hover: #6b7280;\n\n  --bg-popover: #2f2e2f;\n  --color-border-popover: #434342;\n  --bg-hover-popover: #414043;\n\n  /* icon */\n  --color-hamburger: #fff;\n}\n\n\n[data-theme='light'] img:not( [data-no-invert] ) {\n  filter: invert(1);\n}\n\nbody {\n    margin: 0;\n    padding: 0;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
